import * as React from 'react';
import { IsologoProps } from '..';

export const AppleMusicIsologo: React.FC<IsologoProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 11" {...props}>
      <path
        fill={props.fill}
        fillRule="evenodd"
        d="M9,8.05c0,.2,0,.39-.05.6-.04.2-.12.39-.25.55-.12.17-.28.31-.46.41-.18.1-.38.16-.58.2-.39.08-.65.09-.9.04-.24-.05-.44-.15-.61-.3-.24-.21-.39-.5-.43-.8-.04-.35.08-.73.36-1.01.14-.14.31-.25.55-.34.24-.09.51-.15.93-.23.11-.02.22-.04.33-.06.14-.03.27-.06.37-.18.1-.12.1-.26.1-.4v-3.56c0-.27-.13-.35-.4-.3-.19.04-4.36.84-4.36.84-.23.05-.32.13-.32.41v5.22c0,.2-.01.39-.06.6-.04.2-.12.39-.25.55-.12.17-.28.31-.46.41-.18.1-.38.17-.58.21-.39.08-.65.09-.9.04-.24-.05-.44-.16-.61-.3-.24-.21-.38-.5-.42-.8-.04-.35.07-.73.35-1.01.14-.14.31-.25.55-.34.24-.09.51-.15.93-.23.11-.02.22-.04.33-.06.14-.03.27-.06.37-.18.1-.12.11-.25.11-.39V1.66c0-.08,0-.14.01-.16.02-.13.07-.24.17-.31.08-.06.18-.11.31-.13h0S8.13.08,8.13.08c.04,0,.41-.07.45-.07.27-.02.42.15.42.42v7.63Z"
      />
    </svg>
  );
};

export default AppleMusicIsologo;
